var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import { toYuan, toFen } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'payForm',
    props: {
        btnName: {
            types: String,
            default: '确定',
        },
        isOpenLimit: {
            types: Boolean,
            default: true,
        },
        times: {
            types: Number,
            default: '',
        },
    },
    computed: __assign({}, mapState('balance', {
        balanceData: 'balanceData',
    }), { draw: function () {
            return this.balanceData ? this.balanceData.draw : 0;
        },
        isablePurchase: function () {
            return (this.isOpenLimit &&
                (this.draw === 0 || this.ruleForm.amount > this.draw));
        } }),
    data: function () {
        return {
            ruleForm: {
                times: '',
                amount: '',
            },
            rules: {
                times: [
                    { required: true, message: '购买次数不能为空', trigger: 'change' },
                    { validator: this.checkInteger, trigger: 'change' },
                ],
            },
        };
    },
    created: function () {
        this.initForm();
    },
    methods: {
        initForm: function () {
            var times = this.times;
            this.ruleForm.times = times;
            !isNaN(times) && times > 0 && (this.ruleForm.amount = times * 10);
        },
        changeYuan: function (val) {
            return toYuan(val);
        },
        checkInteger: function (rule, value, callback) {
            // 验证是否为小于100的整数
            var _a = this, draw = _a.draw, isOpenLimit = _a.isOpenLimit;
            var res = /^\s*[1-9][0-9]{0,}\s*$/;
            if (!res.test(value)) {
                return callback(new Error('请输入正整数'));
            }
            if (isOpenLimit && toFen(value) * 0.1 > draw) {
                return callback(new Error('可⽤余额不足，建议选择其他⽀付方式'));
            }
            callback();
        },
        autoCount: function (num) {
            var res = /^\s*[1-9][0-9]{0,}\s*$/;
            var amount;
            if (res.test(num)) {
                amount = toFen(num) * 0.1;
            }
            this.ruleForm.amount = amount;
        },
        getForm: function () {
            var _this = this;
            this.$refs['ruleForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                _this.$emit('get-formdata', {
                    data: Object.assign({}, _this.ruleForm),
                    ref: _this.$refs['ruleForm'],
                    form: _this.ruleForm,
                });
            });
        },
    },
});
